import { Field, FieldProps } from 'formik';
import { IEditField, IFieldName } from './formTools';
import { Input, TextButton, Text } from '@zillow/constellation';
import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { DateTime } from 'luxon';
import { EditFieldControls } from './EditFieldControls';
import { FlexGrowFormField } from './FlexGrowFormField';
import { getTaskDueDateFontColor } from './taskDueDateFontColor';

export const TimeDisplay: React.FC<ITaskEditFormDisplayProps & IFieldName> = ({ task, setIsEditing, fieldName }) => {
  const thisDate = task[fieldName];

  const text = (thisDate && DateTime.fromISO(thisDate).toLocal().toFormat('h:mm a ZZZZ')) ?? 'No Time';
  const fontColor = fieldName === 'dueDate' ? getTaskDueDateFontColor(thisDate) : undefined;

  return (
    <TextButton
      buttonType={'primary'}
      onClick={setIsEditing}
      disabled={!setIsEditing}
      fontType={'bodySmall'}
      data-test-id="edit-time-display"
    >
      <Text fontColor={fontColor} fontType={'bodySmall'}>
        {text ?? 'No Date'}
      </Text>
    </TextButton>
  );
};

export const EditTimeField: React.FC<IEditField & IFieldName> = ({ submitOnChange, cancel, fieldName }) => {
  return (
    <EditFieldControls submitOnChange={submitOnChange} cancel={cancel} fieldName={`${fieldName}Time`}>
      <Field name={`${fieldName}Time`}>
        {({ field }: FieldProps) => {
          return (
            <FlexGrowFormField>
              <Input
                {...field}
                type={'time'}
                required
                value={field.value ?? ''}
                onChange={(e) => {
                  field.onChange(e);
                }}
              />
            </FlexGrowFormField>
          );
        }}
      </Field>
    </EditFieldControls>
  );
};
